export default "__VITE_ASSET__ShLFqVI8xue0ZXbFLAmM8g__";